import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import { DailySvrTableData } from "features/ms6/core/domain/DailySvrTableData.model";
import {
  DailySvrTableDataResponse,
  DailySvrTableDataRepository,
} from "features/ms6/data/ms6.repository";

export enum dailySvrTableDataState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  loading: any;
  status: dailySvrTableDataState;
  message: string;
  data: DailySvrTableData | undefined;
}

const initialState: InitialState = {
  status: dailySvrTableDataState.initial,
  message: "",
  data: undefined,
  loading: undefined,
};

export const dailySvrTableData = createAsyncThunk(
  "dailySvrTableData",
  async (_, { rejectWithValue }) => {
    try {
      const response: DailySvrTableDataResponse =
        await DailySvrTableDataRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const dailySvrTableDataSlice = createSlice({
  name: "dailySvrTableData",
  initialState,
  reducers: {
    resetdailySvrTableData: (state) => {
      state.status = dailySvrTableDataState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dailySvrTableData.pending, (state) => {
        state.status = dailySvrTableDataState.inProgress;
      })
      .addCase(dailySvrTableData.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = dailySvrTableDataState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(dailySvrTableData.rejected, (state, action) => {
        state.status = dailySvrTableDataState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectdailySvrTableData = (state: RootState) =>
  state.dailySvrTableData;
export const { resetdailySvrTableData } = dailySvrTableDataSlice.actions;
export default dailySvrTableDataSlice.reducer;
